import { createCrudService } from './createCrudService';
import { del, get, put } from '../apiService';
import type {
  ProductionRunDto,
  ProductionRunCreateDto,
  ProductionRunUpdateDto,
  ProductionRunPagedResponseDto,
  ChemicalDto,
  ChemicalCreateDto,
  ChemicalUpdateDto,
  ChemicalTypeDto,
  SupplierDto,
  CountryDto,
  CountryCreateDto,
  CountryUpdateDto,
  MachineDto,
  MachineCreateDto,
  MachineUpdateDto,
  MachineTypeDto,
  MachineTypeCreateDto,
  MachineTypeUpdateDto,
  MachineFpLengthDto,
  MachineFpLengthUpsertDto,
  FoamTypeDto,
  MachinePumpAssignmentDto,
  MachinePumpAssignmentCreateDto,
  MachinePumpAssignmentUpdateDto,
  PumpCalibrationDto,
  WeatherObservationDto,
} from '../../types/foam';

// Référentiels en lecture seule côté UI métier (type catalog) - typés avec un payload vide.
type ReadOnlyCrud = Record<string, never>;

export const productionRunService = {
  ...createCrudService<ProductionRunDto, ProductionRunCreateDto, ProductionRunUpdateDto>(
    '/ProductionRuns'
  ),
  getPaged: (page: number, pageSize: number, search?: string) => {
    const params = new URLSearchParams({
      page: String(page),
      pageSize: String(pageSize),
    });
    const trimmedSearch = search?.trim();
    if (trimmedSearch) {
      params.set('search', trimmedSearch);
    }
    return get<ProductionRunPagedResponseDto>(`/ProductionRuns/paged?${params.toString()}`);
  },
};

export const chemicalService = createCrudService<ChemicalDto, ChemicalCreateDto, ChemicalUpdateDto>(
  '/Chemicals'
);

export const chemicalTypeService = createCrudService<ChemicalTypeDto, ReadOnlyCrud, ReadOnlyCrud>(
  '/ChemicalTypes'
);

export const supplierService = createCrudService<SupplierDto, ReadOnlyCrud, ReadOnlyCrud>(
  '/Suppliers'
);

export const countryService = createCrudService<CountryDto, CountryCreateDto, CountryUpdateDto>(
  '/Countries'
);

const machineCrud = createCrudService<MachineDto, MachineCreateDto, MachineUpdateDto>('/Machines');

export const machineService = {
  ...machineCrud,
  listFpLengths: (machineId: number) =>
    get<MachineFpLengthDto[]>(`/Machines/${machineId}/fplengths`),
  upsertFpLength: (machineId: number, slotNo: number, dto: MachineFpLengthUpsertDto) =>
    put<MachineFpLengthDto>(`/Machines/${machineId}/fplengths/${slotNo}`, dto),
  deleteFpLength: (machineId: number, slotNo: number) =>
    del(`/Machines/${machineId}/fplengths/${slotNo}`),
};

export const machineTypeService = createCrudService<
  MachineTypeDto,
  MachineTypeCreateDto,
  MachineTypeUpdateDto
>('/MachineTypes');

export const foamTypeService = createCrudService<FoamTypeDto, ReadOnlyCrud, ReadOnlyCrud>(
  '/FoamTypes'
);

export const pumpCalibrationService = createCrudService<
  PumpCalibrationDto,
  ReadOnlyCrud,
  ReadOnlyCrud
>('/PumpCalibrations');

export const machinePumpAssignmentService = createCrudService<
  MachinePumpAssignmentDto,
  MachinePumpAssignmentCreateDto,
  MachinePumpAssignmentUpdateDto
>('/MachinePumpAssignments');

export const weatherObservationService = createCrudService<
  WeatherObservationDto,
  ReadOnlyCrud,
  ReadOnlyCrud
>('/WeatherObservations');
